<template>
  <div :style="styleObject">
    <div :id="id" :style="styleObject"></div>
  </div>
</template>

<script>
  import Wangeditor from 'wangeditor'
  export default {
    props: ['id', 'value', 'text', 'col', 'width', 'height', 'uploadImgUrl', 'disabled', 'menus', 'mapKey', 'menuFixed', 'pasteFilter', 'codeDefaultLang', 'hideLinkImg', 'uploadParams', 'uploadHeaders', 'isRealtime', 'fileMaxSize', 'fileUnit', 'usePlupload', 'disabledMenus'],
    data() {
      return {
        styleObject: {
          // width: '600px',
          height: '400px'
        },
        editor: null,
        defaultMenu: ['bold', 'underline', 'italic', 'strikethrough', 'eraser', 'forecolor', 'bgcolor', 'img', 'video', 'location', 'insertcode', 'quote', 'fontfamily', 'fontsize', 'head', 'unorderlist', 'orderlist', 'alignleft', 'aligncenter', 'alignright', 'link', 'unlink', 'table', 'emotion', 'undo', 'redo', 'fullscreen']
      }
    },
    methods: {
      // 设置尺寸
      initSize() {
        if (this.width) {
          // if (this.col == 10) {
          //   this.styleObject.width = '650px'
          // } else if (this.col == 20) {
          //   this.styleObject.width = '510px'
          // } else if (this.col == 30) {
          //   this.styleObject.width = '300px'
          // } else {
          //   this.styleObject.width = this.width + 'px'
          // }
          this.styleObject.minWidth = '100px'
        }
        if (this.height) {
          this.styleObject.height = this.height + 'px'
        }
      },
      // 创建编辑器
      createEditor() {
        if (!document.getElementById(this.id)) {
          setTimeout(() => {
            this.createEditor(this.id)
          }, 100)
          return
        }
        this.editor = new Wangeditor(this.id)
        if (this.usePlupload) { // 若使用plupload插件上传，则配置初始化函数
          this.editor.config.customUpload = true
          this.editor.config.customUploadInit = this.uploadInit
        } else { // 否则使用原有方法
          this.editor.config.uploadImgUrl = this.uploadImgUrl
          this.editor.config.uploadImgFns.onload = (resultText, xhr) => {
            let res = JSON.parse(resultText)
            if (res.code == 200) {
              let url = imgUrl + res.data
              let originalName = this.editor.uploadImgOriginalName || ''
              this.editor.command(null, 'insertHtml', '<img src=' + url + ' style="max-width:100%;"/>')
              this.$emit('load', originalName)
            } else {
              _g.toastMsg(this, 'error', res.error)
              this.$emit('error')
            }
          }
          this.editor.config.uploadImgFns.ontimeout = (xhr) => {
            this.$emit('timeout')
          }
          this.editor.config.uploadImgFns.onerror = (xhr) => {
            this.$emit('error')
          }
          this.editor.config.uploadImgFileName = 'file'
        }
        this.editor.config.pasteFilter = false
        if (this.mapKey != undefined) {
          // 配置地图key，默认空
          this.editor.config.mapAk = this.mapKey
        }
        if (this.menus != undefined && this.menus instanceof Array && this.menus.length) {
          // 配置菜单，默认全部，对source进行过滤
          this.editor.config.menus = this.filterMenu(this.menus)
        } else if (this.disabledMenus) {
          // 禁用菜单
          this.editor.config.menus = this.filterDisabledMenu(this.defaultMenu, this.disabledMenus)
        } else {
          this.editor.config.menus = this.filterMenu(this.defaultMenu)
        }
        if (this.menuFixed != undefined) {
          // 配置菜单栏吸顶，默认true
          this.editor.config.menuFixed = this.menuFixed
        }
        if (this.pasteFilter != undefined) {
          // 配置粘贴过滤，默认为false
          this.editor.config.pasteFilter = this.pasteFilter
        }
        if (this.codeDefaultLang != undefined) {
          // 默认代码类型，默认javascript
          this.editor.config.codeDefaultLang = this.codeDefaultLang
        }
        if (this.hideLinkImg != undefined) {
          // 隐藏添加网络图片功能，默认显示
          this.editor.config.hideLinkImg = this.hideLinkImg
        }
        if (this.uploadParams != undefined && this.uploadParams instanceof Object) {
          // 上传图片自定义参数
          this.editor.config.uploadParams = this.uploadParams
        }
        if (this.uploadHeaders != undefined && this.uploadHeaders instanceof Object) {
          // 上传图片自定义头部
          this.editor.config.uploadHeaders = this.uploadHeaders
        }
        this.editor.create()
        if (this.value) {
          this.setHtml(this.value)
        }
        if (this.disabled) {
          this.disable()
        }
        this.listenChange()
      },
      // 使用plupload插件配置初始化函数
      uploadInit() {
        try {
          let btnId = this.editor.customUploadBtnId
          let containerId = this.editor.customUploadContainerId
          // 实例化一个上传对象
          let uploader = new plupload.Uploader({
            browse_button: btnId, // 选择文件的按钮的id
            url: this.uploadImgUrl, // 上传地址
            filters: {
              mime_types: [
                // 只允许上传图片文件
                { title: '图片文件', extensions: 'jpg,jpeg,png,bmp,gif,tiff' }
              ]
            }
          })
          let urls = []
          uploader.init()
          // 绑定文件添加到队列事件
          uploader.bind('FilesAdded', (uploader, files) => {
            // 检测上传文件大小是否超出配置值
            let overSize = false
            let maxSize = 2
            let unitCode = 20
            switch (this.fileUnit) {
              case 'KB':
                unitCode = 10
                break
              case 'MB':
                unitCode = 20
                break
            }
            if (this.fileMaxSize) {
              maxSize = parseInt(this.fileMaxSize)
            }
            _(files).forEach((file) => {
              if (!this.checkFileSize(maxSize, unitCode, file.size)) {
                overSize = true
                _g.toastMsg(this, 'error', `图片大小不能超过${this.fileMaxSize}${this.fileUnit}`)
                return
              }
            })
            if (overSize) {
              return false
            }
            uploader.start()
          })
          // 单文件上传之后
          uploader.bind('fileUploaded', (uploader, file, res) => {
            let url = JSON.parse(res.response).data
            urls.push(url)
          })
          // 全部文件上传时候
          uploader.bind('UploadComplete', (uploader, files) => {
            try {
              _(urls).forEach((res) => {
                let realUrl = imgUrl + res
                this.editor.command(null, 'insertHtml', '<img src=' + realUrl + ' style="max-width:100%;"/>')
              })
            } catch (ex) {
            } finally {
              urls = []
              this.editor.hideUploadProgress()
              this.$emit('load')
            }
          })
          // 上传进度条
          uploader.bind('UploadProgress', (uploader, file) => {
            this.editor.showUploadProgress(file.percent)
          })
          // 上传出错时
          uploader.bind('Error', (uploader, error) => {
            this.$emit('error')
          })
        } catch (ex) {
          console.error(ex)
          return
        }
      },
      // 筛选编辑器菜单
      filterMenu(menus) {
        return _.map(menus, (item, key) => {
          if (item === 'source') {
            return null
          }
          return item
        })
      },
      // 筛选不可用菜单
      filterDisabledMenu(menus, disabledMenus) {
        let menusToString = menus.join(',')
        _(disabledMenus).forEach((res) => {
          menusToString = menusToString.replace(res, '').replace(',,', ',')
        })
        if (menusToString.length && menusToString[0] == ',') {
          menusToString.substr(1, menusToString.length)
        }
        return menusToString.split(',')
      },
      // 获取内容(html)
      getHtml() {
        return this.editor.$txt.html()
      },
      // 获取内容(纯文本)
      getText() {
        return this.editor.$txt.text()
      },
      // 设置内容(html)
      setHtml(text) {
        this.editor.$txt.html(text)
      },
      // 追加内容(html)
      appendHtml(text) {
        this.editor.$txt.append(text)
      },
      // 清空内容
      clear() {
        this.editor.clear()
      },
      // 启用编辑器
      enable() {
        this.editor.enable()
      },
      // 禁用编辑器
      disable() {
        this.editor.disable()
      },
      // 销毁编辑器
      destroy() {
        this.editor.destroy()
      },
      // 恢复编辑器
      undestroy() {
        this.editor.undestroy()
      },
      // 监听内容改变
      listenChange() {
        this.editor.onchange = () => {
          this.$emit('change')
          if (this.isRealtime !== false) {
            this.$emit('input', this.getHtml())
          }
        }
      },
      checkFileSize(size, unitCode, fileSize) {
        let maxSize = 0
        let mul = 1024 * (unitCode == 10 ? 1 : 1024)  // 10：KB，20：MB
        maxSize = ~~size * mul
        if (fileSize <= maxSize) {
          return true
        }
        return false
      }
    },
    created() {
      this.initSize()
      this.createEditor()
    },
    watch: {
      'value'() {
        if (this.value != this.getHtml()) {
          this.setHtml(this.value)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// honrayEditor.vue?5e2bddef